import { SUPPORTED_CHAINS } from 'config/chains'

export const SUPPORT_ONLY_BSC = SUPPORTED_CHAINS
export const SUPPORT_FARMS = SUPPORTED_CHAINS

export const SUPPORT_ZAP = []
